<template lang="pug">
div
    div(
        v-if="tabs.length > 1"
        class="px-3 border-b"
    )
        div(class="lg:container overflow-x-scroll lg:overflow-visible")
            div(class="flex flex-nowrap gap-x-4 lg:justify-end")
                template(v-for="(tab, index) in tabs")
                    NuxtLink(
                        :to="tab.route"
                        class="whitespace-nowrap pb-2 pt-2.5 border-b-2 uppercase text-current"
                        :class="[ $route.name === tab.route.name ? 'border-action' : 'border-transparent']"
                    ) {{ tab.name }}

    NuxtChild(keep-alive)

    DoubleWarrantyModal(v-if="activeOverlay === 'doubleWarrantyModal'")

</template>

<script>
import DoubleWarrantyModal from './_components/doubleWarrantyModal'

export default {
    components: {
        DoubleWarrantyModal,
    },
    asyncData({ $sitewideData, $googlePlaces, $geolocation, error }) {
        if (
            !$sitewideData.config.dealerLocatorEnabled ||
            !$geolocation.enabled ||
            !$googlePlaces.enabled
        )
            return error({ statusCode: 404, message: 'Invalid URL' })
    },
    computed: {
        activeOverlay() {
            return this.$overlay.state.activeOverlay
        },
        tabs() {
            const tabs = [
                {
                    name: 'Local Dealers',
                    route: {
                        name: 'dealer-locator',
                    },
                },
            ]

            if (this.$sitewideData.config.dealerLocatorInternationalEnabled) {
                tabs.push({
                    name: 'International Dealers',
                    route: {
                        name: 'dealer-locator-international',
                    },
                })
            }

            if (this.$sitewideData.config.dealerLocatorOnlineEnabled) {
                tabs.push({
                    name: 'Online Dealers',
                    route: {
                        path: '/online-dealers/',
                    },
                })
            }

            return tabs
        },
    },
}
</script>
